{
  "version": 1,
  "asset_id": "8ef1b4d6-79ea-4e3a-a04a-c4c51515022a",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/8ef1b4d6-79ea-4e3a-a04a-c4c51515022a/texturerad-crop-sida.png",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/8ef1b4d6-79ea-4e3a-a04a-c4c51515022a/texturerad-crop-sida.png",
  "original_filename": "texturerad-crop-sida.png",
  "size": 2245657,
  "content_type": "image/png",
  "created_at": "2026-09-08T13:59:22Z"
}
